// Get Inventory Statistics Use Case

import {InventoryRepository} from '../repository/InventoryRepository';
import {InventoryStatistics} from '../models/inventory.model';

export class GetInventoryStatisticsUseCase {
  constructor (private inventoryRepository: InventoryRepository) {}

  async execute (): Promise<InventoryStatistics> {
    try {
      const statistics = await this.inventoryRepository.getInventoryStatistics();
      return statistics;
    } catch (error) {
      throw error;
    }
  }
}
